import { style } from 'typestyle'
export const pl20 = style({ paddingLeft: '20px' })
